<div class="mr-2 mt-2 sticky-parent">
  @for (t of toastsService.toasts$ | async; track t) {
    <shared-toast [toast]="t" (toastHidden)="onToastHidden($event)"></shared-toast>
  }
</div>
